import type { MutationTree } from 'vuex'
import type { AdminPanelState, AdminPanelAccountRow, UpdateServiceStatusPayload } from './types'
import { ADMIN_PANEL_MUTATIONS } from './types'

interface IAdminPanelMutations extends MutationTree<AdminPanelState> {
  [ADMIN_PANEL_MUTATIONS.UPDATE_ACCOUNTS_TABLE_DATA](
    state: AdminPanelState,
    data: AdminPanelAccountRow[]
  ): void
  [ADMIN_PANEL_MUTATIONS.UPDATE_SERVICE_STATUS](
    state: AdminPanelState,
    payload: UpdateServiceStatusPayload
  ): void
}

const mutations: IAdminPanelMutations = {
  [ADMIN_PANEL_MUTATIONS.UPDATE_ACCOUNTS_TABLE_DATA](state, data) {
    state.accounts = data
  },
  [ADMIN_PANEL_MUTATIONS.UPDATE_SERVICE_STATUS](state, { key, status }) {
    state.serviceStatuses[key] = status
  },
}

export default mutations
